import axios from 'axios'
import {
  ServiceModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
} from '../model'
import {TableResumen} from '../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getService(dto: ServiceModel, page: number) {
  return axios.post<ResponseObjectPaginated<ServiceModel[]>>(
    `${BASEURL}/service/getAll/${page}`,
    dto,
  )
}
export function getServiceById(dto: string | undefined) {
  return axios.get<ResponseObject<ServiceModel>>(
    `${BASEURL}/service/getInformationById?pointId=${dto}`,
  )
}

export function createService(dto: ServiceModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/service/createService`, dto)
}

export function deleteService(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/service/deleteService?id=${dto}`)
}

export function updateService(dto: ServiceModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/service/updateService`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/point/downloadTemplateBulkLoadServices`)
}

export function uploadMasiveService(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/service/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
